import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ProductionMaterial {
  order_id: string;
  order_number: string;
  source: string;
  component_name: string | null;
  material_name: string | null;
  material_sku: string | null;
  material_category: string | null;
  quantity: number;
  /** Width in meters (multiply by 1000 for mm) */
  width: number;
  /** Height in meters (multiply by 1000 for mm) */
  height: number;
  /** Thickness in meters (multiply by 1000 for mm) */
  thickness: number;
  unit_cost: number | null;
  notes: string | null;
  source_id: string;
  source_model_name: string | null;
  product_model_name: string | null;
}

export function useProductionMaterials(orderNumber?: string) {
  return useQuery({
    queryKey: ["production-materials", orderNumber],
    queryFn: async () => {
      let query = supabase
        .from("production_materials_view")
        .select("*")
        .order("order_number");

      if (orderNumber) {
        query = query.eq("order_number", orderNumber);
      }

      const { data, error } = await query;

      if (error) throw error;

      return (data || []).map((row) => ({
        order_id: row.order_id || "",
        order_number: row.order_number || "",
        source: row.source || "manual",
        component_name: row.component_name,
        material_name: row.material_name,
        material_sku: row.material_sku,
        material_category: row.material_category,
        quantity: row.quantity || 1,
        width: row.width_m || 0,
        height: row.height_m || 0,
        thickness: row.thickness_m || 0,
        unit_cost: row.unit_cost,
        notes: row.notes,
        source_id: row.source_id || "",
        source_model_name: row.source_model_name ?? null,
        product_model_name: row.product_model_name ?? null,
      })) as ProductionMaterial[];
    },
  });
}
